module.exports = __webpack_public_path__ + "img/gift_bg.ac76a1e.png";